/**
 * Runtime types for entity services (framework-agnostic).
 * HTTP-layer types (EntityController, EntityHandler, EntityRuntime) live in
 * src/http/controllers/types.ts.
 */

import type {
  EntityDefinition,
  PaginatedResult,
  EntityQuery,
  ServerEntityQuery
} from '@gzl10/nexus-sdk'

export type { EntityQuery, ServerEntityQuery }

/**
 * Entity service interface - base contract for all entity services.
 */
export interface EntityService<T = unknown> {
  findAll(query?: EntityQuery): Promise<PaginatedResult<T>>
  findById(id: string): Promise<T | null>
  create?(data: Partial<T>): Promise<T>
  update?(id: string, data: Partial<T>): Promise<T>
  delete?(id: string, options?: { actorId?: string }): Promise<void>
  count?(filters?: Record<string, unknown>): Promise<number>
  readonly definition: EntityDefinition
}
